export const FAQ_CATEGORIES = [
  {
    id: 'bien-commencer',
    label: 'Bien commencer',
    questions: [
      {
        q: "C'est quoi KartQuiz, en une phrase ?",
        a: "KartQuiz est une plateforme française de quiz interactifs gamifiés sous forme de course de kart : chaque bonne réponse fait avancer le kart du joueur sur un circuit en temps réel, avec des bonus d'attaque et de défense entre participants.",
      },
      {
        q: 'Comment créer mon premier quiz ?',
        a: "Crée un compte gratuit, accède à ton espace, puis clique sur « Nouveau quiz ». Tu peux saisir tes questions manuellement, les importer, ou taper un sujet dans l'IA pour qu'elle les génère en quelques secondes. Une fois le quiz prêt, tu lances la partie et partages le code à tes élèves.",
      },
      {
        q: 'Combien de temps faut-il pour préparer une partie ?',
        a: "Avec la génération par IA, tu peux créer un quiz de 15 questions et lancer une partie en moins de 3 minutes. Si tu préfères saisir tes propres questions, compte 20 à 30 minutes selon le nombre de questions.",
      },
      {
        q: "Faut-il une formation pour l'utiliser ?",
        a: "Non. KartQuiz est conçu pour être pris en main sans formation. Le flux est linéaire : créer un quiz → lancer la partie → partager le code → animer. Aucun paramétrage technique n'est requis.",
      },
    ],
  },
  {
    id: 'cote-eleves',
    label: 'Côté élèves / participants',
    questions: [
      {
        q: 'Mes élèves doivent-ils créer un compte ?',
        a: "Non. Les élèves rejoignent une partie KartQuiz en flashant un QR code ou en saisissant un code à 6 caractères depuis le navigateur de leur téléphone. Aucune inscription, aucune adresse email, aucune application à installer. Seul l'enseignant qui crée et lance la partie a besoin d'un compte.",
      },
      {
        q: "Faut-il télécharger une application ?",
        a: "Non. KartQuiz fonctionne entièrement dans le navigateur web, sur mobile comme sur ordinateur. Tes élèves ouvrent leur navigateur (Chrome, Safari, Firefox…), saisissent le code, et c'est parti.",
      },
      {
        q: 'Quels téléphones sont compatibles ?',
        a: "Tous les smartphones récents avec un navigateur web à jour (iOS Safari 14+, Android Chrome 90+). KartQuiz est optimisé pour les petits écrans, y compris les appareils de 3 à 4 ans. Pas d'app à installer, pas de GPS, pas de caméra requise.",
      },
      {
        q: "Que se passe-t-il si un élève perd la connexion ?",
        a: "L'élève peut se reconnecter avec le même code de partie et retrouver son kart à la position où il était. La partie continue pour les autres sans interruption.",
      },
      {
        q: "Combien d'élèves peuvent jouer en même temps ?",
        a: "Pendant la bêta, la limite est fixée à 30 joueurs par partie. C'est conçu pour une classe entière. Le modèle freemium à venir précisera les limites par plan.",
      },
    ],
  },
  {
    id: 'cote-pedagogique',
    label: 'Côté pédagogique',
    questions: [
      {
        q: 'KartQuiz fonctionne-t-il pour toutes les disciplines ?',
        a: "Oui. KartQuiz est utilisé en maths, histoire-géo, langues vivantes, SVT, physique-chimie, philo, lettres, sciences éco, droit, médecine… Tout ce qui peut se formuler en QCM peut devenir une course KartQuiz. L'IA peut générer des questions sur n'importe quel sujet en précisant le niveau scolaire.",
      },
      {
        q: "Peut-on l'utiliser pour évaluer (note formative) ?",
        a: "KartQuiz est conçu pour la révision et l'évaluation formative, pas pour la notation officielle. À la fin de la course, tu as accès aux statistiques par élève et par notion, ce qui te permet d'identifier les lacunes sans attribuer de note.",
      },
      {
        q: "Comment l'IA génère les quiz ?",
        a: "Tu décris ton sujet en langage naturel (ex : « 15 questions sur les fractions, niveau CM2 »). Le modèle d'IA génère les questions, les 4 choix de réponse et désigne la bonne réponse. Tu peux relire, modifier ou supprimer chaque question avant de lancer.",
      },
      {
        q: "Puis-je modifier les questions générées par l'IA ?",
        a: "Oui, chaque question générée est entièrement modifiable : énoncé, choix de réponses, bonne réponse, difficulté, image associée. Tu gardes le contrôle total du contenu.",
      },
      {
        q: 'Que voient les élèves à la fin de la course ?',
        a: "Chaque élève reçoit un récapitulatif personnalisé classant ses questions en trois catégories : Maîtrisé (répondu juste du premier coup), Acquis après correction (répondu juste après s'être trompé), À réviser (n'a pas répondu juste). Ce récapitulatif aide l'élève à cibler ses révisions.",
      },
      {
        q: "Comment je sais ce qu'il faut retravailler avec ma classe ?",
        a: "La vue statistiques de fin de partie te montre, pour chaque sous-thème et chaque question, le taux de bonnes réponses, le nombre d'erreurs et le nombre de timeouts. En un coup d'œil, tu identifies les notions qui ont posé problème à l'ensemble de la classe.",
      },
    ],
  },
  {
    id: 'tarifs',
    label: 'Tarifs et bêta',
    questions: [
      {
        q: "C'est vraiment gratuit ?",
        a: "Oui, pendant la bêta, KartQuiz est entièrement gratuit : création de quiz illimitée, génération par IA incluse, toutes les fonctionnalités de course disponibles, joueurs illimités par partie. Aucune carte bancaire requise.",
      },
      {
        q: "Que se passera-t-il à la fin de la bêta ?",
        a: "KartQuiz passera à un modèle freemium : un plan gratuit (Découverte) permettra d'animer des parties avec les quiz de la communauté, et un plan payant à bas prix (Pro) ajoutera la création de quiz personnalisés et la génération IA. Les comptes bêta auront un avantage de fidélité.",
      },
      {
        q: 'Les établissements peuvent-ils avoir un tarif groupé ?',
        a: "Ce n'est pas encore proposé, mais c'est dans la roadmap. Écris-nous à contact@kartquiz.fr si tu veux être contacté en priorité pour les offres établissements.",
      },
    ],
  },
  {
    id: 'technique',
    label: 'Technique et confidentialité',
    questions: [
      {
        q: 'Mes données et celles de mes élèves sont-elles protégées ?',
        a: "Les données des enseignants (email, nom) sont stockées en Europe via Supabase. Les élèves ne créent pas de compte : seul un pseudo libre est demandé au moment de rejoindre la partie, sans email ni identifiant nominal. Les données de partie sont supprimées 30 jours après la fin.",
      },
      {
        q: 'KartQuiz est-il conforme au RGPD ?',
        a: "Oui. KartQuiz collecte le minimum requis : email et nom pour les comptes enseignants, pseudo anonyme pour les joueurs. Aucun cookie publicitaire. Aucun tracking d'élève nominatif. Tu peux exercer tes droits (accès, rectification, suppression) en écrivant à contact@kartquiz.fr.",
      },
      {
        q: 'Hébergement en France ou en Europe ?',
        a: "Le frontend est déployé sur Vercel (CDN mondial, serveurs edge en Europe). La base de données et les données utilisateurs sont hébergées sur Supabase dans la région Europe (Frankfurt). KartQuiz est édité par BCOMING.Digital, société française basée à Lyon.",
      },
      {
        q: 'Puis-je utiliser KartQuiz hors connexion ?',
        a: "Non. KartQuiz requiert une connexion internet pour fonctionner, côté animateur comme côté joueur. La synchronisation en temps réel est au cœur de l'expérience.",
      },
    ],
  },
  {
    id: 'comparaison',
    label: "Comparaison avec d'autres outils",
    questions: [
      {
        q: "KartQuiz, c'est comme Kahoot ?",
        a: "KartQuiz et Kahoot sont tous deux des outils de quiz interactifs pour la classe, mais leur mécanique est différente. Kahoot propose un quiz linéaire synchrone où tous les joueurs voient la même question en même temps. KartQuiz propose une course de kart où chaque joueur avance à son propre rythme, avec des bonus d'attaque et de défense. KartQuiz repose aussi les questions ratées automatiquement — ce que Kahoot ne fait pas.",
      },
      {
        q: 'Pourquoi pas Wooclap ?',
        a: "Wooclap est excellent pour le polling, les nuages de mots et les questions ouvertes en amphithéâtre. KartQuiz est complémentaire : il est conçu pour la révision gamifiée et l'interaction entre joueurs, pas pour le sondage en temps réel. Si tu fais surtout du polling en cours magistral, Wooclap reste un très bon choix. Si tu veux une révision active et compétitive, KartQuiz est plus adapté.",
      },
      {
        q: 'KartQuiz pour le supérieur, ça marche ?',
        a: "Oui. KartQuiz est utilisé en TD à l'université, en formations professionnelles et en IFSI. L'univers cartoon « adulte » (trottinette, T-rex, astronaute…) ne tombe pas dans l'infantilisant. La limite de 30 joueurs par partie couvre la majorité des TD. Pour des amphis de 200 personnes, Wooclap reste plus adapté.",
      },
    ],
  },
]

export const FAQ_HOME = [
  FAQ_CATEGORIES[1].questions[0],
  FAQ_CATEGORIES[1].questions[4],
  FAQ_CATEGORIES[1].questions[1],
  FAQ_CATEGORIES[3].questions[0],
  FAQ_CATEGORIES[0].questions[0],
]
